var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockMuller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 11.0156H18.326V6.19746C18.326 2.78016 15.4871 0 11.9978 0C8.50852 0 5.66971 2.78016 5.66971 6.19746V11.0156H3.5625C1.62398 11.0156 0.046875 12.5927 0.046875 14.5312V26.4844C0.046875 28.4229 1.62398 30 3.5625 30H20.4375C22.376 30 23.9531 28.4229 23.9531 26.4844V14.5312C23.9531 12.5927 22.376 11.0156 20.4375 11.0156ZM8.01346 6.19746C8.01346 4.0725 9.80086 2.34375 11.9978 2.34375C14.1948 2.34375 15.9822 4.0725 15.9822 6.19746V11.0156H8.01346V6.19746ZM21.6094 26.4844C21.6094 27.1305 21.0837 27.6562 20.4375 27.6562H3.5625C2.91633 27.6562 2.39062 27.1305 2.39062 26.4844V14.5312C2.39062 13.8851 2.91633 13.3594 3.5625 13.3594H20.4375C21.0837 13.3594 21.6094 13.8851 21.6094 14.5312V26.4844Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7578C10.8026 16.7578 9.83203 17.7284 9.83203 18.9258C9.83203 19.6903 10.2281 20.3619 10.826 20.7479V23.3203C10.826 23.9675 11.3506 24.4922 11.9978 24.4922C12.645 24.4922 13.1697 23.9675 13.1697 23.3203V20.7507C13.7699 20.3651 14.168 19.6922 14.168 18.9258C14.168 17.7284 13.1974 16.7578 12 16.7578Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockMuller);
export default __webpack_public_path__ + "static/media/lock_muller.564a02fd725b4b76f6068e52edd95441.svg";
export { ForwardRef as ReactComponent };